import React from 'react'
import { LandingPagePreviewMain } from 'src/components/landing-page'

/** Preset picker, landing page URL / edit button and live preview. */
const LandingTab = () => <LandingPagePreviewMain />

export default LandingTab
